/**
 * fusionStyleCore.js — таблицы цвета/прозрачности наложения МРТ, чистая часть.
 *
 * Вынесено из rtRegisterModule._styleOverlay: сами ТОЧКИ передаточных функций —
 * математика, и её можно проверить тестом; vtk-вызовы остаются модулю.
 *
 * [7.0.23] Заодно закрыт вырожденный случай: у «плоского» тома (range[0] ===
 * range[1] — бывает на обрезанной серии) прежний код ставил несколько точек на
 * ОДИН X — поведение передаточной функции при дублях не определено, слой мог
 * стать невидимым или мигать. Теперь диапазон принудительно расширяется.
 */

/** Нормализованный диапазон: непустой, возрастающий. */
export function safeRange(range) {
  let lo = Number(range?.[0]), hi = Number(range?.[1]);
  if (!Number.isFinite(lo)) lo = 0;
  if (!Number.isFinite(hi)) hi = lo + 1;
  if (hi <= lo) hi = lo + 1;
  return [lo, hi];
}

/**
 * Точки цветовой функции: тёплая карта (тёмно-красный → жёлтый) —
 * МРТ поверх серого КТ хорошо видно.
 * @returns {Array<[x, r, g, b]>}
 */
export function fusionColorPoints(range) {
  const [lo, hi] = safeRange(range);
  return [
    [lo, 0.30, 0.0, 0.0],
    [(lo + hi) / 2, 0.95, 0.35, 0.0],
    [hi, 1.0, 0.95, 0.35],
  ];
}

/**
 * Точки функции прозрачности: нулевая у дна (фон МРТ не глушит КТ),
 * рабочая прозрачность с 10% диапазона и до верха.
 * @returns {Array<[x, opacity]>}
 */
export function fusionOpacityPoints(range, opacity) {
  const [lo, hi] = safeRange(range);
  const op = Math.max(0, Math.min(1, Number(opacity) || 0));
  return [
    [lo, 0.0],
    [lo + (hi - lo) * 0.1, op],
    [hi, op],
  ];
}

export default { safeRange, fusionColorPoints, fusionOpacityPoints };
